module.exports = __webpack_public_path__ + "static/media/ic_service_layout_default.8ee706fb.svg";